module.exports = __webpack_public_path__ + "img/compass_pointer.5fbf4911.png";